// extracted by mini-css-extract-plugin
export default {"welcome-container":"vk6_t3SXtN5BFNIxWCGd","btn-container":"o9_btZNo_flnOo9bfRGn"};